<template>
  <Modal
    class=""
    hide-close-button
    :modal-style="{ width: '450px' }"
    :title="displayTitle"
  >
    <p>
      This will create a new identical incomplete request for this cancelled
      item.
    </p>
    <template #buttons>
      <QBtn
        class="q-mr-md text-black"
        flat
        label="Cancel"
        @click="$emit('close')"
      />
      <QBtn
        class="no-shadow bg-primary text-white"
        label="Create"
        @click="createRequest"
      />
    </template>
  </Modal>
</template>

<script>
import Modal from "shared/components/core/modals/Modal.vue";

export default {
  name: "NewMediaOrTranscriptRequestModal",
  components: {
    Modal,
  },
  props: {
    type: {
      type: String,
      default: null,
    },
  },
  emits: ["close", "create"],
  data() {
    return {};
  },
  computed: {
    displayTitle() {
      return `Create new ${this.type} request from cancelled item`;
    },
  },
  mounted() {},
  methods: {
    createRequest() {
      this.$emit("create");
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.streem-modal2-buttons) {
  padding-top: 0;
}

:deep(.streem-modal2-header) {
  align-self: flex-start;
}
</style>
